import { createReducer, on } from '@ngrx/store';
import {
  IBillCategory,
  IBillCategoryDetailsResponse,
  IEMData,
} from '@dch/billing-business-logic';
import * as CategoryDetailsActions from '../actions/category-details.actions';

export interface IBillCategoryDetailsState {
  billCategoryDetailsByDocumentReference: {
    [documentReference: string]: {
      [category in IBillCategory]?: IEMData<IBillCategoryDetailsResponse>;
    };
  };
}

export const initialState: IBillCategoryDetailsState = {
  billCategoryDetailsByDocumentReference: {},
};

export const categoryDetailsReducer = createReducer(
  initialState,
  on(
    CategoryDetailsActions.getCategoryDetailsRequest,
    (state, { documentReference, category }) => ({
      ...state,
      billCategoryDetailsByDocumentReference: {
        ...state.billCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.billCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: null,
            isFetching: true,
            hasError: false,
          },
        },
      },
    })
  ),
  on(
    CategoryDetailsActions.getCategoryDetailsSuccess,
    (state, { documentReference, category, payload }) => ({
      ...state,
      billCategoryDetailsByDocumentReference: {
        ...state.billCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.billCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: payload,
            isFetching: false,
            hasError: false,
          },
        },
      },
    })
  ),
  on(
    CategoryDetailsActions.getCategoryDetailsFailure,
    (state, { documentReference, category }) => ({
      ...state,
      billCategoryDetailsByDocumentReference: {
        ...state.billCategoryDetailsByDocumentReference,
        [documentReference]: {
          ...state.billCategoryDetailsByDocumentReference[documentReference],
          [category]: {
            result: null,
            isFetching: false,
            hasError: true,
          },
        },
      },
    })
  )
);
